import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Restangular } from 'ngx-restangular';
//import { CoreService } from '../core/core.service';
import { Observable, of } from 'rxjs';

export interface Credentials {
  statusCode: string;
  message: string;
  token: string;
}
export interface LoginContext {
  userName: string;
  password: string;
  phoneNumber: string;
  pin: string;
  remember?: boolean;
}

const credentialsKey = 'credentials';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _credentials: Credentials | null = null;

  constructor(@Inject(Restangular) public Restangular: any) {
    const savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  redirectToLogin():void {
    debugger;

  }
  

  get credentials(): Credentials | null {
    return this._credentials;
  }

  signIn(context: LoginContext): Observable<Credentials> {
    return this.Restangular.one('users/login').customPOST(context);
  }

  signUp(context: any): Observable<any> {
    return this.Restangular.one('users/create').customPOST(context);
  }

  getSubscriber(context: any): Observable<any> {
    return this.Restangular.one('subscribers/subscriber?userId=' + context).customGET('');
  }

  subscribe(context: any): Observable<any> {
    return this.Restangular.one('subscribers/create').customPOST(context);
  }

  changePassword(context: any): Observable<any> {
    return this.Restangular.one('users/changePassword').customPUT(context);
  }

  activate(context: any): Observable<any> {
    return this.Restangular.one('users/activate').customPUT(context);
  }

  forgot(context: any): Observable<any> {
    return this.Restangular.one('users/forgotPassword').customPUT(context);
  }

  markNotification(context: any): Observable<any> {
    return this.Restangular.one('notifications/changeStatus').customPUT(context);
  }

  getNotifications(page: number, all = false, option: string) {
    if (all) {
      return this.Restangular.one('notifications?all=' + all + option).customGET('');
    }
    return this.Restangular.one('notifications?page=' + page + option).customGET('');
  }

  getSubscriptions(page: number, all = false) {
    if (all) {
      return this.Restangular.one('subscribers/subscriptions?page=' + all).customGET('');
    }
    return this.Restangular.one('subscribers/subscriptions?page=' + page).customGET('');
  }

  reset(context: any): Observable<any> {
    return this.Restangular.one('users/resetPassword').customPUT(context);
  }

  signOut(): Observable<boolean> {
    this.setCredentials();
    return of(true);
  }

  setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;
    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }
}
